<template>
    <div class="com-container">
        <div class="com-chart" style="display: flex;">
        <div style="width: 49.9%;" ref="seller_erf"></div>
        <div style="width: 49.9%;" ref="seller_erf1"></div>
    </div>
    </div>
</template>
<script>
// 表盘
export default {
    data() {
        return {
            chartInstance: null,
            allDate: null,
            allDate0: null,
            allDate1: null,
            JGname:null,
            timerId: null, 
            yj:0

        }},
    mounted() { 
        this.getData();
        this.initChart();
        window.addEventListener("resize", this.screenAdapter);
        this.screenAdapter();
    },
    destroyed() {
        clearInterval(this.timerId);
        window.removeEventListener("resize", this.screenAdapter);
    },
    methods: {
        initChart() {       
            this.chartInstance = this.$echarts.init(this.$refs.seller_erf, "dark");
            this.chartInstance1 = this.$echarts.init(this.$refs.seller_erf1, "dark");
            const initOption = {
                // title: {
                //     text: ` ▎${this.allDate.sName}   出水口`,
                //     left: 20,
                //     top: 1,
                // },
                grid: {
                    top: "40%",
                    left: "3%",
                    right: "6%",
                    bottom: "5%",
                    containLabel: true, // 包含坐标轴上的文字
                },
                series: [
                    {
                        type: 'gauge',
                        axisLine: {
                            lineStyle: {
                                width: 30,
                                color: [
                                    [0.3, '#67e0e3'],
                                    [0.75, '#37a2da'],
                                    [1, '#fd666d']
                                ]
                            }
                        },
                        pointer: {
                            itemStyle: {
                                color: 'auto'
                            }
                        },
                        axisTick: {
                            distance: -30,
                            length: 8,
                            lineStyle: {
                                color: '#fff',
                                width: 2
                            }
                        },
                        splitLine: {
                            distance: -30,
                            length: 30,
                            lineStyle: {
                                color: '#fff',
                                width: 4
                            }
                        },
                        axisLabel: {
                            show: false,
                            color: 'inherit',
                            distance: 40,
                            fontSize: 20
                        },
                        detail: {
                            valueAnimation: true,
                            formatter: '{value} ℃',
                            color: 'inherit',
                            offsetCenter: [0, '95%']
                        },
                        data: [
                            {
                            }
                        ]
                    }
                ]
            };
            const initOption1 = {
                // title: {
                //     text: `${this.syData.cTemperature.title}`,
                //     left: 20,
                //     top: 1,
                // },
                grid: {
                    top: "40%",
                    left: "3%",
                    right: "6%",
                    bottom: "5%",
                    containLabel: true, // 包含坐标轴上的文字
                },
                series: [
                    {
                        type: 'gauge',
                        axisLine: {
                            lineStyle: {
                                width: 30,
                                color: [
                                    [0.3, '#67e0e3'],
                                    [0.75, '#37a2da'],
                                    [1, '#fd666d']
                                ]
                            }
                        },
                        pointer: {
                            itemStyle: {
                                color: 'auto'
                            }
                        },
                        axisTick: {
                            distance: -30,
                            length: 8,
                            lineStyle: {
                                color: '#fff',
                                width: 2
                            }
                        },
                        splitLine: {
                            distance: -30,
                            length: 30,
                            lineStyle: {
                                color: '#fff',
                                width: 4
                            }
                        },
                        axisLabel: {
                            show: false,
                            color: 'inherit',
                            distance: 40,
                            fontSize: 20
                        },
                        detail: {
                            valueAnimation: true,
                            formatter: '{value} ℃',
                            color: 'inherit',
                            offsetCenter: [0, '95%']
                        },
                        data: [
                            {
                            }
                        ]
                    }
                ]
            };
            this.chartInstance.setOption(initOption);
            this.chartInstance1.setOption(initOption1);
        },
        async getData() {
            const { data: ret } = await this.$http.get("sensor/getTemperature");
            this.allDate=ret
             this.allDate0 = this.allDate.find(user => Number(user.sId) === 5)
             this.allDate1 = this.allDate.find(user => Number(user.sId) === 6)
            this.startInterver();
        },
        // 更新图标
        startInterver() {
            if (this.timerId) {
                clearInterval(this.timerId);
            }
            // this.getData()
            // 设置定时器2
            this.timerId = setInterval(() => {
                this.getData()
                this.chartInstance.setOption({
                                    title: {
                    text: ` ▎${this.allDate0.sName} `,
                    left: 20,
                    top: 1,
                },
                    series: [
                        {
                            data: [
                                {
                                    value:this.allDate0.sTemperature
                                }
                            ]
                        }
                    ]
                });
                this.chartInstance1.setOption({
                                    title: {
                    text: `${this.allDate1.sName.slice(3,6)}`,
                    left: 20,
                    top: 1,
                },
                    series: [
                        {
                            data: [
                                {
                                    value:this.allDate1.sTemperature
                                }
                            ]
                        }
                    ]
                });
            }, 1000);
        },
        // 浏览器发生变化时调用次方法，完成浏览器适配1
        screenAdapter() {
            this.titleFontSize = (this.$refs.seller_erf.offsetWidth / 100) * 3.6;
            const adapterOption = {
                title: {
                    textStyle: {
                        fontSize: this.titleFontSize*2,
                    },
                }
            };
            this.chartInstance.setOption(adapterOption);
            this.chartInstance1.setOption(adapterOption);
            this.chartInstance.resize();
            this.chartInstance1.resize();
        },
    },
};
</script>
<style lang="less" scoped></style>